import mockecommerce from '../assets/images/mock-ecommerce_app.jpg';
import mockgotv from "../assets/images/mock-gotv_app.jpg";
import mocklegal from '../assets/images/mock-legalservice_app.jpg';
import mockpos from '../assets/images/mock-pos_app.jpg';
import '../assets/styles/Project.scss';

function Project() {
    return (
      <div
        className="projects-container"
        id="projects"
      >
        <h1>Personal Projects</h1>
        <div className="projects-grid">
          <div className="project">
            <a
              href="https://commerce.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={mockecommerce}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </a>
            <a
              href="https://commerce.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <h2>E-Commerce</h2>
            </a>
            <p>
              A fully functional e-commerce platform built with React JS and Express JS,
              featuring secure payment integration, a responsive user interface,
              and robust database management for product catalog, inventory, and
              order tracking.
            </p>
          </div>
          <div className="project">
            <a
              href="https://pos.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={mockpos}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </a>
            <a
              href="https://pos.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <h2>POS System</h2>
            </a>
            <p>
              A point-of-sale system designed for small and medium businesses,
              offering real-time inventory tracking, sales analytics, multi-user
              support, and seamless receipt generation with React and Flask
              integration.
            </p>
          </div>
          <div className="project">
            <a
              href="https://techtest.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={mocklegal}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </a>
            <a
              href="https://techtest.si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <h2>Legal Service</h2>
            </a>
            <p>
              A registration platform specialized in company legal services,
              providing tools to streamline business registration, document
              preparation, and compliance management, built with React JS and
              Express JS for a seamless user experience.
            </p>
          </div>
          <div className="project">
            <a
              href="https://si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={mockgotv}
                className="zoom"
                alt="thumbnail"
                width="100%"
              />
            </a>
            <a
              href="https://si-kom.com"
              target="_blank"
              rel="noreferrer"
            >
              <h2>GOTV Election App</h2>
            </a>
            <p>
              A Get-Out-The-Vote (GOTV) application aimed at increasing voter
              turnout, featuring real-time notifications, interactive maps,
              volunteer coordination, and user-friendly voter registration
              tools.
            </p>
          </div>
        </div>
      </div>
    );
}

export default Project;